/**
 * Author：brand
 * Creation Time：2019-06-14 14:01
 * Email：brandhuang@qq.com
 */
import ax from '../axios'

/**
 * 上传图片
 * @param params
 */
export function uploadImageAPI(params) {
  return ax({
    url: '/wlapi/resource/uploadImgFile',
    method: 'post',
    data:params
  })
}

/**
 * 上传文件
 * @param params
 */
export function uploadFileAPI(params) {
  return ax({
    url: '/wlapi/resource/uploadFile',
    method: 'post',
    data:params
  })
}

/**
 * 上传视频
 * @param params
 */
export function uploadVideoAPI(params) {
  return ax({
    url: '/wlapi/resource/uploadVideoFile',
    method: 'post',
    data:params
  })
}


/**
 * 上传音频
 * @param params
 */
export function uploadVoiceAPI(params) {
  return ax({
    url: '/wlapi/resource/uploadAudioFile',
    method: 'post',
    data:params
  })
}
